module.exports = __webpack_public_path__ + "img/deposit-gold.bbd063e1.svg";